// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Report_attributes_AtributosCategoriaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /so/report_attributes/atributos_categoria/{category_id}
 *
 * Returns the report-attribute bindings configured for the given service
 * category. Legacy `dados` shape is a list, so getDados() returns the
 * array directly.
 */
import type { Report_attributes_CategoryBindingRow } from './Report_attributes_CategoryBindingRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Report_attributes_AtributosCategoriaResponseDados = Report_attributes_CategoryBindingRow[];

export type Report_attributes_AtributosCategoriaResponse = ApiResponse<Report_attributes_AtributosCategoriaResponseDados>;

registerResponseContract('Report_attributes_AtributosCategoriaResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      so_cra_id:            { type: 'number',  required: true },
      so_cra_category_id:   { type: 'number',  required: true },
      so_cra_attribute_id:  { type: 'number',  required: true },
      so_cra_required:      { type: 'number',  required: true },
      so_cra_display_order: { type: 'number',  required: true },
      so_cra_report_type:   { type: 'string',  required: true },
      so_cra_created_at:    { type: 'string',  required: true },
      so_ra_id:             { type: 'number',  required: true },
      so_ra_name:           { type: 'string',  required: true },
      so_ra_type:           { type: 'string',  required: true },
    },
  },
})
